import { FileEntryBM } from '@bm-js/atlascloud-shared'
import { createContext } from 'react'

export interface MediaSelector {
  fileType: 'image' | 'pdf' | 'video' | undefined
  onSelect: (f: FileEntryBM | undefined) => void
}

interface MediaState {
  media: MediaSelector | null
  openMediaSelector: (args: MediaSelector) => void
  closeMediaSelector: () => void
}

export const MediaContext = createContext<MediaState>({
  media: null,
  openMediaSelector: () => {},
  closeMediaSelector: () => {},
})
